import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('ContentContainer')(() =>
  css({
    display: 'flex',
    width: '100%',
    maxHeight: ['calc(100dvh - 245px)', 'calc(100dvh - 245px)', '450px'],
    flexDirection: 'column',
    overflowY: 'auto',
    overflowX: 'hidden',
  }),
);

themeStyles.addBaseStyles('SummaryDescriptionContainer')(() =>
  css({
    display: 'flex',
    width: '100%',
    pb: 'xs',
  }),
);

themeStyles.addBaseStyles('ContentInnerContainer')(({ numberOfConflicts }) =>
  css({
    display: 'flex',
    flexDirection: numberOfConflicts > 1 ? 'column' : ['column', 'column', 'row'],
    justifyContent: numberOfConflicts > 1 ? 'flex-start' : 'center',
    gap: numberOfConflicts > 1 ? ['0'] : ['0', '0', '40px'],
    width: '100%',
  }),
);

themeStyles.addBaseStyles('SelectionsContainer')(() =>
  css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    paddingBottom: '10px',
    width: ['100%', '100%', 'auto'],
  }),
);

themeStyles.addBaseStyles('ConflictsContainer')(() =>
  css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    paddingBottom: '10px',
    width: ['100%', '100%', 'auto'],
  }),
);

themeStyles.addBaseStyles('CardsContainer')(() =>
  css({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    gap: '24px',
  }),
);

themeStyles.addBaseStyles('PriceChangeContainer')(
  css({
    display: 'flex',
    width: '100%',
    backgroundColor: 'infoLabel',
    justifyContent: 'space-between',
    py: 'xs',
    px: 's',
    my: 'xs',
  }),
);

themeStyles.addBaseStyles('PriceChangeLabel')(
  css({
    lineHeight: ['sm', 'sm', 'md'],
    fontSize: ['14px', '14px', '16px'],
  }),
);

themeStyles.addBaseStyles('SelectionsSubheading')(
  css({
    fontFamily: 'bold',
    pb: '10px',
  }),
);

themeStyles.addBaseStyles('PriceChangeValue')(
  css({
    fontFamily: 'bold',
    fontSize: ['14px', '14px', '16px'],
    lineHeight: ['sm', 'sm', 'md'],
  }),
);

export default themeStyles;
